import { GameContext } from "./GameContext";
import { useReducer, useCallback, useState, useEffect } from "react";




const reducerfxn = (currentGames, action) => {
  let games = currentGames;
  if (action.type === "DELETE_GAME") {
    games = currentGames.filter((game) => game.id !== action.payload.gameId);
  } else if (action.type === "ADD_INITIAL_GAMES") {
    games = action.payload.games;
  } else if (action.type === "ADD_GAME") {
    games = [action.payload, ...currentGames];
  }
 else if (action.type === "EDIT_game") {
    // Logic to update the game in the current games
    games = currentGames.map((game) =>
      game.id === action.payload.id ? { ...game, ...action.payload } : game
    );
  }

  return games;
};

const GameContextProvider = ({ children }) => {
  const [gameList, dispatchGameList] = useReducer(reducerfxn, []);
  const [fetching, setFetching] = useState(false);
  const addGame = (game) => {
    const addGameObject = {
      type: "ADD_GAME",
      payload: game,
    };
    dispatchGameList(addGameObject);
  };

  const deleteGame = useCallback(
    (gameId) => {
      const deleteAction = {
        type: "DELETE_GAME",
        payload: {
          gameId,
        },
      };
      dispatchGameList(deleteAction);
    },
    [dispatchGameList]
  );

  const addGamesFromServer = (games) => {
    const addInitialgames = {
      type: "ADD_INITIAL_GAMES",
      payload: {
        games,
      },
    };

    dispatchGameList(addInitialgames);
  };

  const editGame = (game) =>{
    const editGameObject= {
      type: "EDIT_POST",
      payload: game,
    };
    dispatchGameList(editGameObject);

  }

  useEffect(() => {
  //console.log('GameContextProvider mounted');
  return () => {
    //console.log('GameContextProvider unmounted');
  };
}, []); // This will log only when the provider is mounted/unmounted


  return (
    <GameContext.Provider
      value={{ gameList, addGame, deleteGame, fetching, setFetching ,addGamesFromServer ,editGame }}
    >
      {children}
    </GameContext.Provider>
  );
};

export default GameContextProvider;
